





















import { getUserData } from "@/auth/getUserData";
import { useChannelsStore } from "@/store/useChannelsStore";
import { getChannelSettingValue } from "@/utils/channels";
import { defineComponent, PropType } from "@vue/composition-api";

export default defineComponent({
    props: {
        position: {
            type: String as PropType<"prepend" | "append">,
            required: true,
        },
    },
    setup() {
        const showAutomaticSignature = (settingValue: "prepend-agent-name-bold" | "append-agent-name"): boolean => {
            const channelsStore = useChannelsStore();

            //!isTemplate.value &&
            //!isQuickReply.value &&
            return (
                getUserData().displayName &&
                settingValue === getChannelSettingValue(channelsStore.activeChatChannel, "automaticSignature")
            );
        };

        return {
            showAutomaticSignature,
            getUserData,
        };
    },
});
